import { ENRICHMENT_ROOT_API_PREFIX } from '@aibees/elephant/constants';
import { ERROR_CODES } from '@aibees/elephant/constants/error-codes';
import {
  CreateEnrichmentRequest,
  CreateEnrichmentResponse,
} from '@aibees/elephant/types';
import { HttpMethod } from '@aibees/shared/definition';
import { useNotify } from '@aibees/shared/hooks';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';

export function useCreateEnrichmentMutationApi() {
  const workspaceId = useWorkspace()?.id;
  const notify = useNotify();

  return useBaseMutation<CreateEnrichmentRequest, CreateEnrichmentResponse>(
    {
      url: ENRICHMENT_ROOT_API_PREFIX.replace(':wid', String(workspaceId)),
      method: HttpMethod.post,
    },
    {
      onError(error, _request) {
        if (error.cause.subCode === ERROR_CODES.ENRICHMENT_WRONG_MAPPING) {
          notify.warning(
            'Mapping Error',
            'The columns were not matched correctly. Please check your mapping and try again',
            'enrichment-mapping-error',
            {
              icon: 'view-in-ar',
            }
          );
        } else {
          notify.error(error.message ?? 'An error occurred.');
        }
      },
      doNotShowErrorNotification: true,
    }
  );
}
